import { z } from 'zod';

import { fileResponseSchema } from './fileSchemas';

// #region N14 — 장바구니
/**
 * 장바구니 항목 = FileResponse + 접근 가능 여부.
 * `accessible=false`면 담은 뒤 권한을 잃은 항목이다(CART-06 백엔드 요청 — 서버가 이름·경로를
 * 가린다). 아직 내려오지 않으면 undefined → 접근 가능으로 본다(다운로드는 서버가 제외).
 */
export const cartItemSchema = fileResponseSchema.extend({
  accessible: z.boolean().nullish(),
});
export type CartItem = z.infer<typeof cartItemSchema>;

/** GET /cart — envelope 없이 항목 배열 그대로 온다 */
export const cartListSchema = z.array(cartItemSchema);
export type CartList = z.infer<typeof cartListSchema>;

/** POST /cart/items · DELETE /cart/items · POST /cart/download 공용 바디 (CartItemsRequest) */
export const cartItemsBodySchema = z.object({
  fileIds: z.array(z.number()).min(1),
});
export type CartItemsBody = z.infer<typeof cartItemsBodySchema>;
// #endregion

// N15 — POST /cart/download 응답은 common의 bulkDownloadCreatedSchema (N13과 동일 계약)
